import React, { useState, useEffect } from "react";
import classes from "./ManageUser.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { Pen, Trash2 } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from 'sweetalert2'


const ManageUser = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewModalOpen, setIsNewModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [NewUser, setNewUser] = useState([]);
    // const [delUser, setDelUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [stores, setStores] = useState([]);

    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const pageMap = {
        "/dashboard": "Dashboard",
        "/transactions": "Transactions",
        "/accounts": "Accounting",
        "/reports": "Reports",
        "/banking": "Banking",
        "/settings": "Settings",
    };

    const [formData, setFormData] = useState({
        name: "",
        phone_no: "",
        address: "",
        image: null,
    });
    const [selectedStore, setSelectedStore] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            const payload = new FormData();
            payload.append("store_name", formData.name);
            payload.append("store_address", formData.address);
            payload.append("phone_number", formData.phone_no);

            if (formData.image) {
                payload.append("image", formData.image);
            }

            const body = withCompanyId(payload);
            const response = await api.post(`/v1/store/create`, body);

            setFormData({
                name: "",
                phone_no: "",
                address: "",
                image: null,
            });

            setIsModalOpen(false);

            Swal.fire({
                icon: "success",
                title: "Store Added",
                text: response.data.message || "Store created successfully!",
                timer: 1500,
                showConfirmButton: false,
            }).then(() => {
                window.location.reload();
            });


        } catch (error) {
            console.error("❌ Error:", error.response?.data || error.message);

            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Add Store",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };

    const [deleteStore, setDeleteStore] = useState(null);




    const handleDeleteStore = async () => {
        if (!deleteStore) return;

        try {
            setSubmitting(true);
            const res = await api.get(`/v1/store/delete`, { params: { id: deleteStore.id } });

            Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: res.data.message || "Store deleted successfully.",
                timer: 2000,
                showConfirmButton: false,
            });

            setStores((prev) => prev.filter((s) => s.id !== deleteStore.id));
            setIsDeleteModalOpen(false);
            setDeleteStore(null);
        } catch (error) {
            console.error("Delete error:", error.response?.data || error.message);

            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Delete Store",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };




    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleUpdateStore = async (e) => {
        e.preventDefault();
        if (!selectedStore) return;

        try {
            setSubmitting(true);
            const payload = new FormData();
            payload.append("id", selectedStore.id);
            payload.append("store_name", selectedStore.store_name);
            payload.append("store_address", selectedStore.store_address);
            payload.append("phone_number", selectedStore.phone);

            if (selectedStore.image instanceof File) {
                payload.append("image", selectedStore.image);
            }

            const body = withCompanyId(payload);
            const res = await api.post(`/v1/store/update`, body);

            Swal.fire({
                icon: "success",
                title: "Store Updated",
                text: res.data.message || "Store updated successfully!",
                timer: 2000,
                showConfirmButton: false,
            });


            setStores((prev) =>
                prev.map((s) => (s.id === selectedStore.id ? selectedStore : s))
            );

            setIsNewModalOpen(false);
            setSelectedStore(null);
        } catch (error) {
            console.error("Update error:", error.response?.data || error.message);

            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Update Store",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };




    useEffect(() => {
        const authToken = localStorage.getItem('authToken');

        if (!authToken) {
            setError("Authorization token not found.");
            navigate('/signin');
            return;
        }

        const fetchStores = async () => {
            try {
                const res = await api.get(`/v1/store`);

                const storeData = res.data?.data?.data || res.data?.data || [];
                setStores(storeData);
            } catch (err) {
                console.error("Error fetching store:", err?.response?.data || err.message);
                setError(err.response?.data?.message || "Failed to fetch stores. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchStores();
    }, [navigate]);







    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.PgeContainerDisp}>
                <div className={classes.actionsbtn_On}>

                    <button className={classes.btns_New}
                        onClick={() => navigate('/transactions/sales-invoice/sale')}>Sales Invoice</button>
                    <button className={classes.btns_New}
                        onClick={() => navigate('/inventory/purchaseOrder')}>Purchase Invoice</button>
                    {/* <button className={classes.btns_New}>All Invoices</button> */}
                    <button className={`${classes.btns_New} ${classes.greens}`}
                        onClick={() => navigate('/settings/product-services')}>Product & Services</button>
                    <button className={`${classes.btns_News} ${classes.greens}`}>Manage Store</button>
                </div>
                <header className={classes.FrtHeaderOne}>
                    <h2 className={classes.FrtTitleOne}>Manage Store</h2>
                </header>


{/* Cards commented out for now, can be re-enabled if needed in the future. */}
                {/* <div className={classes.entrjjyer}>
                    <div className={classes.allkadsPage}>
                        <div className={classes.thrdkadPage}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>Total Stores</p>
                                <p className={classes.kdptgpt1}>0</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>This month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkadIs}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>Outstanding</p>
                                <p className={classes.kdptgpt2}>₦0.00</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>Pending payments</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkadOn}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>Overdue</p>
                                <p className={classes.kdptgpt3}>₦0.00</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>Past due dates</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkadOne}>
                            <div className={classes.kadOne}>
                                <p className={classes.kdptgpt}>This month</p>
                                <p className={classes.kdptgpt4}>0</p>
                                <div className={classes.rvnueOpt}>
                                    <p className={classes.skaltxt001}>Total invoices</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className={classes.headerforActions}>
                    <div className={classes.actionsSideRight}>
                        <div className={classes.inputWrapperTxt}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreenLrg} />
                            <input type="text" className={classes.searchLxtBar} placeholder="Search user" />
                        </div>

                    </div>
                    <button
                        className={classes.btnssBtnss}
                        onClick={() => setIsModalOpen(true)}>Manage Store</button>
                </div>

                <div className={classes.newUserCont}>
                    <table className={classes.newUserTable}>
                        <table className={classes.newUserTable}>
                            <thead style={{ whiteSpace: "nowrap" }}>
                                <tr>
                                    <th>ID</th>
                                    <th>Store Name</th>
                                    <th>Address</th>
                                    <th>Phone</th>
                                    {/* <th>Image</th> */}
                                    <th className={classes.actionMove}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    Array(5)
                                        .fill()
                                        .map((_, idx) => (
                                            <tr key={idx}>
                                                {Array(5)
                                                    .fill()
                                                    .map((_, i) => (
                                                        <td key={i}>
                                                            <Skeleton height={20} style={{ marginBottom: 10 }} />
                                                        </td>
                                                    ))}
                                            </tr>
                                        ))
                                ) : stores.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} style={{ textAlign: "center" }}>
                                            No Store found.
                                        </td>
                                    </tr>
                                ) : (
                                    stores.map((store, index) => (
                                        <tr key={store.id}>
                                            <td>{index + 1}</td>
                                            <td>{store.store_name}</td>
                                            <td>{store.store_address || "—"}</td>
                                            <td>{store.phone || "—"}</td>
                                            {/* <td>
                                                {store.image ? (
                                                    <img
                                                        src={store.image}
                                                        alt={store.store_name}
                                                        style={{ width: "40px", height: "40px", borderRadius: "6px" }}
                                                    />
                                                ) : (
                                                    "No Image"
                                                )}
                                            </td> */}
                                            <td className={classes.actionsEditDelete}>
                                                <Pen
                                                    size={16}
                                                    className={classes.editActionIcon}
                                                    onClick={() => {
                                                        setSelectedStore(store);
                                                        setIsNewModalOpen(true);
                                                    }}
                                                />
                                                <Trash2
                                                    size={16}
                                                    className={classes.deleteActionIcon}
                                                    onClick={() => {
                                                        setDeleteStore(store);
                                                        setIsDeleteModalOpen(true);
                                                    }}
                                                />

                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>



                        </table>


                    </table>

                    <div className={classes.paginationContainertxt}>
                        <div className={classes.paginationControlstxt}>
                            <button>First</button>
                            <button className={classes.activation}>1</button>
                            <button>Last</button>
                            <span className={classes.pageDisplayText}>Displaying 1 - 41 of 41</span>
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        {/* Modal Header */}
                        <div className={classes.modalModalHeader}>
                            <h2>Manage Store</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => setIsModalOpen(false)}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Modal Body */}
                        <form onSubmit={handleSubmit}>
                            <div className={classes.modalModalBody}>
                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Store Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Enter Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className={classes.modalFormGroup}>
                                        <label>Phone Number</label>
                                        <input
                                            type="number"
                                            name="phone_no"
                                            placeholder="Enter Phone Number"
                                            value={formData.phone_no}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={classes.modalFormGroup}>
                                    <label>Upload Image (optional, max 2MB)</label>

                                    <div className={classes.fileUploadWrapper}>
                                        <input
                                            type="file"
                                            id="fileUpload"
                                            name="image"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    if (file.size > 2 * 1024 * 1024) {
                                                        alert("File size exceeds 2MB limit");
                                                        e.target.value = null;
                                                    } else {
                                                        setFormData({ ...formData, image: file });
                                                    }
                                                } else {
                                                    setFormData({ ...formData, image: null });
                                                }
                                            }}
                                        />
                                        <label htmlFor="fileUpload" className={classes.fileUploadBtn}>
                                            Choose File
                                        </label>
                                        <span className={classes.fileName}>
                                            {formData.image ? formData.image.name : ""}
                                        </span>
                                    </div>
                                </div>


                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Address</label>
                                        <input
                                            type="text"
                                            name="address"
                                            placeholder="Enter Address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={classes.modalFormFooter}>
                                    <button
                                        className={classes.processModalBtn0}
                                        disabled={submitting}
                                    >
                                        {submitting ? "Managing..." : "Manage Store"}
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div >
            )}




            {isNewModalOpen && selectedStore && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2>Edit Store</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => {
                                    setIsNewModalOpen(false);
                                    setSelectedStore(null);
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        <form onSubmit={handleUpdateStore}>
                            <div className={classes.modalModalBody}>
                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Store Name</label>
                                        <input
                                            type="text"
                                            value={selectedStore.store_name || ""}
                                            onChange={(e) =>
                                                setSelectedStore({
                                                    ...selectedStore,
                                                    store_name: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                    </div>
                                    <div className={classes.modalFormGroup}>
                                        <label>Phone Number</label>
                                        <input
                                            type="text"
                                            value={selectedStore.phone || ""}
                                            onChange={(e) =>
                                                setSelectedStore({
                                                    ...selectedStore,
                                                    phone: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Address</label>
                                        <input
                                            type="text"
                                            value={selectedStore.store_address || ""}
                                            onChange={(e) =>
                                                setSelectedStore({
                                                    ...selectedStore,
                                                    store_address: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={classes.modalFormFooter}>
                                    <button className={classes.processModalBtn0} disabled={submitting}>
                                        {submitting ? "Updating..." : "Save Changes"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}




            {isDeleteModalOpen && deleteStore && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalDeleteContent}>
                        <div className={classes.modalModalHeader}>
                            <h2 style={{ marginBottom: "auto" }}>Delete Store</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => {
                                    setIsDeleteModalOpen(false);
                                    setDeleteStore(null);
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        <div className={classes.modalModalBodyText00}>
                            <p>
                                Are you sure you want to delete <strong>{deleteStore.store_name}</strong>?
                            </p>
                            <div className={classes.modalFormDelFooter}>
                                <button
                                    className={classes.ModalDeleteBtn0}
                                    onClick={handleDeleteStore}
                                    disabled={submitting}
                                >
                                    {submitting ? "Deleting..." : "Delete Store"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}





            <Footer />
        </div >

    );
};

export default ManageUser;
